export default __webpack_public_path__ + "static/media/icn_check_green.fbd296db.svg";